module.exports = __webpack_public_path__ + "static/media/4_large.772a482c.png";